"use client";

import Time from "@/components/time";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef } from "react";

function Info() {
  const comp = useRef<HTMLDivElement | null>(null);

  useGSAP(
    () => {
      const t1 = gsap.timeline();
      t1.from(["#name", "#title"], {
        opacity: 0,
        y: "+=40",
        stagger: 0.5,
      });
    },
    { scope: comp },
  );

  return (
    <header className="flex flex-col gap-2 overflow-clip" ref={comp}>
      <h1 className="text-xl" id="name">
        S. M. Abdul Aziz
      </h1>
      <p className="text-sm" id="title">
        designer ⇔ developer
      </p>
    </header>
  );
}

export default function Header() {
  return (
    <>
      <div className="min-h-full min-w-full">
        <div className="absolute z-20 top-0 inset-x-0 flex justify-center overflow-hidden pointer-events-none">
          <div className="w-[108rem] flex-none flex justify-end">
            <picture>
              <source srcSet="/beams/docs@30.avif" type="image/avif" />
              <img
                src="/beams/docs@tinypng.png"
                alt=""
                className="w-[71.75rem] flex-none max-w-none dark:hidden"
                decoding="async"
              />
            </picture>
            <picture>
              <source srcSet="/beams/docs-dark@30.avif" type="image/avif" />
              <img
                src="/beams/docs-dark@tinypng.png"
                alt=""
                className="w-[90rem] flex-none max-w-none hidden dark:block"
                decoding="async"
              />
            </picture>
          </div>
        </div>
      </div>

      <div className="p-4 sm:px-0 flex items-center justify-between max-w-xl mx-auto">
        <div className="mt-10 flex items-center gap-2 sm:gap-10">
          <Avatar className="w-16 h-16 animate-bg-border rounded-full bg-white bg-gradient-to-r from-emerald-500 via-purple-500 to-blue-500 bg-[length:400%_400%] p-0.5">
            <AvatarImage
              src="/image/profile.png"
              className="rounded-full object-cover object-top"
              alt="Photo of S. M. Abdul Aziz"
            />
            <AvatarFallback>Sayemon10</AvatarFallback>
          </Avatar>
          <Info />
        </div>
        <Time />
      </div>
      <div className="max-w-xl mx-auto px-4 sm:px-0">
        <p className="w-fit rounded-full bg-secondary px-6 py-2 text-sm flex items-baseline mb-8 ring-1 ring-gray-900/10 dark:ring-gray-100/10">
          <span className="relative flex h-2 w-2 mr-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-sky-500"></span>
          </span>
          Currently looking for Job opportunities
        </p>
      </div>
    </>
  );
}
